// removed by extract-text-webpack-plugin
module.exports = {"example":"styles__example__sDrdJ","exampleHeading":"styles__exampleHeading__2dDJS","exampleCard":"styles__exampleCard__3t2FK","arrow":"styles__arrow__2117U","blue":"styles__blue__1OsWA","badge":"styles__badge__3xP1L","cardBottom":"styles__cardBottom__3VcFH","button":"styles__button__10cuM","exampleImageContainer":"styles__exampleImageContainer__1ywH-","rightHand":"styles__rightHand__3HGAx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Examples/styles.scss
// module id = 389
// module chunks = 0